module.exports = __webpack_public_path__ + "img/545-42dfb3.png";